import React from 'react'
import styles from './TeamFormation.module.css';

const TeamMember = (props) => {
  return (
    <div>
      <hr />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <p className={`  `}  >{props.teamMember.id}</p>
        <h5 className={`  `}  >{props.teamMember.fullname}</h5>
        <p className={`  `}  >({props.teamMember.email})</p>
      </div>
    </div>
  )
}

export default TeamMember